import { Store } from '@types'
import { getProxyUrl } from '.'

export async function copyProyect(idVers: number, clientInfo: Store['clientInfo'], date: Date) {
  const url = getProxyUrl('api/Diseno/duplicardisenyo')
  const disenyo = {
    nombreProyecto: clientInfo.nombreProyecto,
    descripcion: clientInfo.descripcion,
    nombre: clientInfo.nombre,
    apellidos: clientInfo.apellidos,
    direccion: clientInfo.direccion,
    codPostal: clientInfo.codPostal,
    poblacion: clientInfo.poblacion,
    email: clientInfo.email,
    pais: clientInfo.pais,
    movil: clientInfo.movil,
    idDisenos: null,
    idVersiones: null,
  }

  const body = JSON.stringify({
    idVersiones: idVers,
    disenyo,
    fecha: date,
  })

  const params = {
    body,
    method: 'POST',
    mode: 'cors',
    headers: {
      'Accept-Language': 'ES',
      'Content-Type': 'application/json',
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
    },
  }

  try {
    const response = await fetch(url, params as RequestInit)

    if (response.ok) {
      // Caso exitoso: status 200
      return await response.json()
    } else {
      // Caso de error: status no es 200
      const errorDetail = await response.json()
      throw new Error(errorDetail?.detail || 'Ocurrió un error inesperado.')
    }
  } catch (e: any) {
    console.error('Error al duplicar proyecto:', e.message || e)
    throw e // Propagar el error para manejarlo en `handleClick`
  }
}
